<div class="data-model-customization-root">
    <lib-data-model-customization-header [classes]="classes"
        (selectedClass)="selectClass($event)"
        (addNewModal)="addNewFieldOpened = true">
    </lib-data-model-customization-header>
    <lib-data-model-customization-section *ngFor="let section of sectionDefinitions"
        (sectionUpdated)="onSectionUpdated($event)"
        [assetType]="entityType"
        [substationTemplateId]="0"
        [section]="section"
        [utilityId]="utilityId"
        [sectionExpanded]="expandedSectionId == section.id"
        (sectionSaved)="sectionSaved($event)"
        (sectionDeleted)="sectionDeleted($event)">
    </lib-data-model-customization-section>
</div>
<lib-add-new-section *ngIf="addNewFieldOpened"
    [substationTemplateId]="0"
    [assetType]="entityType"
    [utilityId]="utilityId"
    [equipmentType]="classes[selectedClass]?.cimClass"
    [displayOrder]="sectionDefinitions.length + 1"
    (closeModal)="addNewFieldOpened = false"
    (saved)="sectionSaved($event)">
</lib-add-new-section>
